import type { TaskStatus } from "@/lib/tasks/queries";

import {
  TASK_KANBAN_COLUMN_GRADIENT,
  taskKanbanColumnGradientToSurface,
} from "./task-kanban-styles";

type Props = {
  status: TaskStatus;
  /** Blend the column tint into this color at the bottom edge. */
  fadeToColor?: string;
};

/** Tint gradient below the header — full color at the top edge, then fades. */
export function TaskKanbanColumnScrollFade({ status, fadeToColor }: Props) {
  return (
    <div
      aria-hidden
      className="pointer-events-none absolute inset-x-0 top-12 bottom-0 z-0"
      style={{
        background: fadeToColor
          ? taskKanbanColumnGradientToSurface(status, fadeToColor)
          : TASK_KANBAN_COLUMN_GRADIENT[status],
      }}
    />
  );
}
